import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './RadioField.styl';

const cx = classNames.bind(styles);

class RadioField extends PureComponent {
  static defaultProps = {
    className: '',
    checked: false,
    disabled: false,
  };

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    inputRef: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    inputProps: PropTypes.object,
  };

  render() {
    const { className, children, label, inputProps } = this.props;

    const classes = cx('RadioField', className, {
      RadioField_checked: inputProps.checked,
      RadioField_disabled: inputProps.disabled,
    });

    return (
      <div className={classes}>
        <label className={cx('RadioField__field')}>
          <span className={cx('RadioField__caption')}>{label}</span>
          <input {...inputProps} className={cx('RadioField__input')} />
        </label>
        {children && inputProps.checked && (
          <div className={cx('RadioField__content')}>{children}</div>
        )}
      </div>
    );
  }
}

export default RadioField;
